import { Dispatch, SetStateAction, useRef } from 'react'

import StandaloneIframe from '@/app/[locale]/[roomId]/components/StandaloneIframe'
import WorldIframe from '@/app/[locale]/[roomId]/components/WorldIframe'
import { useWorldDetailsContext } from '@/context/WorldDetailsContext'
import { useIframeScrollLock } from '@/hooks/useIframeScrollLock'
import { useIframeTouchOutsideUnLock } from '@/hooks/useIframeTouchOutsideUnLock'

type IframeContentProps = {
  setIsShowSplash: Dispatch<SetStateAction<boolean>>
  setScrollLock?: (isLocked: boolean) => void
}

function IframeContent({ setIsShowSplash, setScrollLock }: IframeContentProps) {
  const { worldMeta } = useWorldDetailsContext()
  const { handlers } = useIframeScrollLock(
    {
      enableFocus: true,
      enableHover: true,
    },
    setScrollLock,
  )

  const iframeRef = useRef<HTMLIFrameElement>(null)
  useIframeTouchOutsideUnLock(iframeRef, setScrollLock)

  return worldMeta?.scene_type === 'standalone' ? (
    <StandaloneIframe setIsShowSplash={setIsShowSplash} handlers={handlers} ref={iframeRef} />
  ) : (
    <WorldIframe setIsShowSplash={setIsShowSplash} handlers={handlers} ref={iframeRef} />
  )
}

export default IframeContent
